import React from "react";
import Logo from "../components/common/Logo";

const PublicLayout = ({ children }) => {
  return (
    <div className="main-wrap" onContextMenu={(e) => e.preventDefault()}>
      <div className="row">
        <div className="col-xl-12 vh-100 align-items-center d-flex bg-white rounded-3 overflow-hidden">
          <div className="card shadow-none border-0 ms-auto me-auto login-card overflow-scroll-mobile">
            <div className="card-body rounded-0 text-center">
              <Logo variant="default" />
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicLayout;
